import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Banner, Button, PolicyLink } from "./styled";

const CookieBanner = () => {
    const { t, i18n } = useTranslation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const accepted = localStorage.getItem("cookiesAccepted");
        if (!accepted) {
            setVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem("cookiesAccepted", "true");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <Banner>
            <p>
                {t("cookies.message")}{" "}
                <PolicyLink
                    to={(i18n.resolvedLanguage || i18n.language)?.startsWith("en") ? "/privacy-policy" : "/polityka-prywatnosci"}
                >
                    {t("cookies.privacyLink")}
                </PolicyLink>
            </p>

            <Button onClick={handleAccept}>
                {t("cookies.accept")}
            </Button>
        </Banner>
    );
};

export default CookieBanner;